import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import Quote from '../../Quote/Quote.jsx';

export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8 push-l4">
                    <Markdown>
                        {contentToText(content['climate-talks-2'],{
                            facequote: <Quote quote="The IMO has fallen flat on its face in the first test of its determination to tackle greenhouse gas emissions after Paris." credit="John Maggs, Senior Policy Advisor at NGO Seas At Risk" position="left"/>
                        })}
                    </Markdown>
                </div>
            </div>
        </div>
    </div>)   
}





// WEBPACK FOOTER //
// ./src/js/components/special/ClimateTalks2/ClimateTalks2.jsx